import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryDirectory from './components/CategoryDirectory';
import AboutSection from './components/AboutSection';
import ArticlePreview from './components/ArticlePreview';
import CTASection from './components/CTASection';
import Testimonials from './components/Testimonials';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kakobuyfinds.blog';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'KakobuyFinds.blog',
  url: siteUrl,
  description: 'The ultimate Kakobuy Spreadsheet hub for smart shopping. Discover curated product finds, shopping guides, comparisons, and trusted resources.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?s={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'KakobuyFinds.blog',
  url: siteUrl,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <Navbar />
      <main>
        <Hero />
        <CategoryDirectory />
        <AboutSection />
        <ArticlePreview />
        <CTASection />
        <Testimonials />
      </main>
      <Footer />
    </>
  );
}